var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconPencil(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("g", { transform: "scale(4 4)" },
            React.createElement("path", { d: "M16.9128 2.0001C17.179 2.00383 17.4327 2.11354 17.6177 2.30492L21.719 6.54696C22.0987 6.93975 22.0929 7.56463 21.706 7.95031L9.85786 19.7592C9.74473 19.872 9.60622 19.956 9.45395 20.0043L3.30205 21.9533C2.9496 22.065 2.56429 21.9731 2.3002 21.7143C2.0361 21.4556 1.93632 21.0722 2.04074 20.7176L3.86352 14.5265C3.91182 14.3624 4.00139 14.2135 4.12365 14.0939L16.1996 2.28503C16.3899 2.09891 16.6466 1.99637 16.9128 2.0001ZM5.70844 15.3415L4.49032 19.4789L8.61816 18.1711L19.5965 7.22904L16.8789 4.41812L5.70844 15.3415Z", fill: color }),
            React.createElement("path", { d: "M13.2928 6.70712L17.2928 10.7071L18.7071 9.29291L14.7071 5.29291L13.2928 6.70712ZM5.41112 14.1368C4.92382 13.8769 4.31808 14.0612 4.05817 14.5485C3.79825 15.0358 3.98259 15.6415 4.46989 15.9015L6.83034 17.1605L8.08084 19.3648C8.35336 19.8451 8.96369 20.0136 9.44406 19.7411C9.92443 19.4686 10.0929 18.8583 9.82042 18.3779L8.42675 15.9212C8.33323 15.7564 8.1948 15.6215 8.02758 15.5323L5.41112 14.1368Z", fill: color }))));
}
//# sourceMappingURL=icon.pencil.component.js.map